import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useBoolean } from '@sravni/react-utils';

import { setSubscriptionPopupVisibility } from '../reducers/user';

import { useIsSubscriptionPopupVisible } from './users';

export const useSubscriptionPopup = (subscriptionPopupState: [number, (value: number) => void]) => {
  const [whenPopupWasShown, setWhenPopupWasShown] = subscriptionPopupState;
  const [isVisible, setIsVisible] = useBoolean();
  const dispatch = useDispatch();
  const isSubscriptionPopupVisible = useIsSubscriptionPopupVisible();

  const onVisible = useCallback(
    (time: number) => {
      if (isSubscriptionPopupVisible || isVisible) return;

      setWhenPopupWasShown(time);
      setIsVisible.on();
      dispatch(setSubscriptionPopupVisibility(true));
    },
    [dispatch, isSubscriptionPopupVisible, isVisible, setIsVisible, setWhenPopupWasShown],
  );

  const onHide = () => {
    setIsVisible.off();
    dispatch(setSubscriptionPopupVisibility(false));
  };

  return {
    whenPopupWasShown,
    isVisible,
    onVisible,
    onHide,
  };
};
